
import axios from '@/utils/request'
// 保存生码配置（后端契约：{ brand_id, data: {...配置字段} }）
export const saveGenConfig = (data) => {
    return axios.request({
        url: 'code/gen/config/save',
        method: 'post',
        data
    })
};
// 获取生码配置
export const getGenConfig = (brand_id, params) => {
    return axios.request({
        url: 'code/gen/config/' + brand_id,
        method: 'get',
        params
    })
};
// 创建生码单
export const createGenOrder = (data) => {
    return axios.request({
        url: 'code/gen/order/create',
        method: 'post',
        data
    })
};
// 生码单列表（后端分页参数为 page_size，此处兼容 hooks 的 limit）
export const getGenOrderList = (params) => {
    return axios.request({
        url: 'code/gen/order/list',
        method: 'get',
        params: { ...params, page_size: params.limit }
    })
};
// 生码单详情
export const getGenOrderDetail = (id) => {
    return axios.request({
        url: 'code/gen/order/' + id,
        method: 'get'
    })
};
// 重试生成（仅重置为待生码，不自动派发队列）
export const retryGenOrder = (id) => {
    return axios.request({
        url: 'code/gen/order/retry/' + id,
        method: 'post'
    })
};
// 修改生码单（待生码/已失败可改，保留批次号）
export const updateGenOrder = (id, data) => {
    return axios.request({
        url: 'code/gen/order/' + id + '/update',
        method: 'post',
        data
    })
};
// 删除生码单（待生码/已失败/已取消可删）
export const deleteGenOrder = (id) => {
    return axios.request({
        url: 'code/gen/order/' + id + '/delete',
        method: 'post'
    })
};
// 手动触发生码（待生码 → 生码中 → 派发队列）
export const startGenOrder = (id) => {
    return axios.request({
        url: 'code/gen/order/' + id + '/start',
        method: 'post'
    })
};
// 取消生码单（仅待生码可取消）
export const cancelGenOrder = (id) => {
    return axios.request({
        url: 'code/gen/order/' + id + '/cancel',
        method: 'post'
    })
};
// 导出码包（返回 JSON，包含下载令牌）
export const exportGenOrder = (id, params) => {
    return axios.request({
        url: 'code/gen/order/export/' + id,
        method: 'get',
        params
    })
};
// 下载导出文件（验证 5 分钟有效期）
export const downloadExportFile = (token) => {
    return axios.request({
        url: 'code/gen/export/download',
        method: 'get',
        params: { token },
        responseType: 'blob'
    })
};
// 查询生码进度
export const getGenOrderProgress = (id) => {
    return axios.request({
        url: 'code/gen/order/progress/' + id,
        method: 'get'
    })
};
